import { atomWithReset, useResetAtom } from 'jotai/utils';

export const searchObjectQuery = atomWithReset<string>('');
export const showSearchBar = atomWithReset<boolean>(false);

export function useResetSearchAtoms() {
  const resetSearchObjectQuery = useResetAtom(searchObjectQuery);
  const resetShowSearchBar = useResetAtom(showSearchBar);
  return () => {
    resetSearchObjectQuery();
    resetShowSearchBar();
  };
}
